import { LOAD_RANKING_OPTIONS, LOAD_OFFICES, LOAD_RANKING_RESPONSE, SET_CONSULTAR_BASES_MODAL } from "../../types/ranking/rankingTypes";
import { IOfficeItem } from "../../types/ranking/rankingTypes";

export const loadRankingOptions = (prop:string, datasave: any) => ({ type: LOAD_RANKING_OPTIONS, payload: {prop, datasave} });

export const loadOffices = (prop:string, offices: IOfficeItem[]) => ({ type: LOAD_OFFICES, payload: {prop, offices} });

export const loadRankingResponse = (prop:string, datasave: any) => ({ type: LOAD_RANKING_RESPONSE, payload: {prop, datasave} });

export const setConsultarBasesModal = (prop:string, datamodal: any) => ({ type: SET_CONSULTAR_BASES_MODAL, payload: {prop, datamodal} });